import React from 'react';
import { Step as MuiStep, Stepper as MuiStepper, StepLabel } from '@mui/material';

import { Step } from './props';

/**
 * @property currentStep - The index of the current step in the wizard.
 * @property steps - An array of steps defining the wizard.
 */
interface ComponentProps {
  currentStep: number;
  steps: Step[];
  className?: string;
}

/**
 * Renders a stepper for the wizard form.
 *
 * displays the current step of the wizard along with the titles of all defined steps.
 *
 * @param  props
 * @returns The rendered stepper component.
 */
export const Stepper: React.FC<ComponentProps> = ({ currentStep, steps, className = 'stepper' }) => {
  return (
    <MuiStepper activeStep={currentStep} className={className}>
      {[...steps].map(({ title, step }, index) => (
        // A step is complete once the wizard has moved past it, which is a comparison between two
        // positions in the same list - so it is made against `index`.
        //
        // It used to read `currentStep - 1 > +step`, comparing the zero-based `currentStep` against
        // the one-based `step` field a Step declares. The two never lined up: on the last step of a
        // five-step wizard only the first two ever ticked, and a wizard whose authors numbered its
        // steps from zero, or not at all, ticked something different again. Using `index` removes
        // the mismatch rather than papering over it, and does not depend on `step` being set
        // correctly.
        <MuiStep key={step || index} completed={index < currentStep}>
          <StepLabel>{title}</StepLabel>
        </MuiStep>
      ))}
    </MuiStepper>
  );
};

export default Stepper;
